import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentsModule} from '../../../components/components.module';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {TextareaModule} from 'primeng/textarea';
import {TranslateModule} from '@ngx-translate/core';
import {RippleModule} from 'primeng/ripple';
import {PipesModule} from '../../../pipes/pipes.module';
import {TooltipModule} from 'primeng/tooltip';
import {MultiSelectModule} from 'primeng/multiselect';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {CampaignGroupComponent} from './campaign-group.component';
import {CampaignGroupEditComponent} from './campaign-group-edit/campaign-group-edit.component';
import {CampaignGroupStatsComponent} from './campaign-group-stats/campaign-group-stats.component';

@NgModule({
    declarations: [CampaignGroupComponent, CampaignGroupEditComponent, CampaignGroupStatsComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        ButtonModule,
        ToastModule,
        ConfirmDialogModule,
        TableModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        TextareaModule,
        TranslateModule,
        RippleModule,
        PipesModule,
        TooltipModule,
        MultiSelectModule,
        ProgressSpinnerModule
    ]
})
export class CampaignGroupModule {
}
